import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { lightTheme } from 'theme';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { ResponsiveCardImg } from 'components/ResponsiveImg';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { MetaTypography, MetaWrapper, ReadingTime } from '../elements/BlogMeta';

const StyledCard = styled(Card)`
  width: 100%;
  display: flex;
  transition: all 0.15s ease-in-out;

  &:hover {
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.15);
  }
`;

const BlogCardContent = styled(CardContent)`
  padding-top: 5px;
`;

const BlogLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const BlogCard = ({ post }) => (
  <MuiThemeProvider theme={lightTheme}>
    <StyledCard>
      <BlogLink to={post.url}>
        {post.hero_image && (
          <ResponsiveCardImg
            src={post.hero_image.url}
            alt={post.title}
            maxWidth={640}
          />
        )}
        <BlogCardContent>
          <MetaWrapper spacing={16} justify="space-between">
            <MetaTypography>
              {post.blog_category.length > 0 && post.blog_category[0].title}
            </MetaTypography>
            <ReadingTime wordCount={post.word_count} />
          </MetaWrapper>
          <Typography gutterBottom variant="h3">
            {post.title}
          </Typography>
        </BlogCardContent>
      </BlogLink>
    </StyledCard>
  </MuiThemeProvider>
);

export default BlogCard;
